import { useCallback, useState } from 'react';
import { toastApi } from '../Toast/toastApi.js';

/** ModalShell deleted Wave-1 cleanup — zero production mounts; use AppModal. */
export {
  Notification,
  NotificationShell,
  type NotificationProps,
} from './NotificationShell.js';

export interface NotificationState {
  readonly show: boolean;
  readonly message: string;
  readonly type: 'success' | 'error' | 'info';
}

export interface UseNotificationReturn {
  readonly notification: NotificationState;
  readonly showNotification: (message: string, type?: 'success' | 'error' | 'info') => void;
  readonly hideNotification: () => void;
}

/** @deprecated Use toastApi directly — kept for P3 screen migrations. */
export function useNotification(): UseNotificationReturn {
  const [notification, setNotification] = useState<NotificationState>({
    show: false,
    message: '',
    type: 'info',
  });

  const showNotification = useCallback(
    (message: string, type: 'success' | 'error' | 'info' = 'info'): void => {
      toastApi(message, type);
      setNotification({ show: true, message, type });
    },
    [],
  );

  const hideNotification = useCallback((): void => {
    setNotification((prev) => ({ ...prev, show: false }));
  }, []);

  return {
    notification,
    showNotification,
    hideNotification,
  };
}
